var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"0":1,"75":1,"84":1,"145":1,"187":1,"321":1,"325":1,"451":1,"512":1,"647":1,"740":1,"786":1,"812":1,"901":1,"964":1,"982":1,"985":1,"1102":1,"1117":1,"1141":1,"1242":1,"1309":1,"1405":1,"1462":1,"1511":1,"1532":1,"1563":1,"1589":1,"1625":1,"1697":1,"1778":1,"1784":1,"1792":1,"1826":1,"1829":1,"1882":1,"1947":1,"2001":1,"2039":1,"2269":1,"2298":1,"2329":1,"2354":1,"2380":1,"2410":1,"2454":1,"2501":1,"2528":1,"2707":1,"2718":1,"2868":1,"2871":1,"3049":1,"3070":1,"3093":1,"3120":1,"3170":1,"3174":1,"3188":1,"3255":1,"3323":1,"3391":1,"3509":1,"3541":1,"3656":1,"3692":1,"3716":1,"3737":1,"3845":1,"3880":1,"4329":1,"4399":1,"4517":1,"4523":1,"4545":1,"4662":1,"4689":1,"4780":1,"4801":1,"4850":1,"4871":1,"4906":1,"5114":1,"5156":1,"5237":1,"5309":1,"5451":1,"5511":1,"5532":1,"5563":1,"5795":1,"5850":1,"6035":1,"6049":1,"6070":1,"6259":1,"6261":1,"6275":1,"6600":1,"6609":1,"6759":1,"6785":1,"6829":1,"6891":1,"6986":1,"7001":1,"7055":1,"7078":1,"7218":1,"7243":1,"7302":1,"7352":1,"7386":1,"7407":1,"7454":1,"7508":1,"7556":1,"7588":1,"7645":1,"7662":1,"7778":1,"7896":1,"7945":1,"7961":1,"7962":1,"8036":1,"8148":1,"8180":1,"8302":1,"8461":1,"8499":1,"8520":1,"8542":1,"8595":1,"8598":1,"8750":1,"8805":1,"8932":1,"9054":1,"9136":1,"9600":1,"9784":1,"9908":1,"9965":1,"9983":1,"9986":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr